class DataError<C extends number | string = string> extends Error {
  readonly code
  readonly cause
  constructor(code: C, message: string, cause?: Error) {
    super(message)

    this.code = code
    this.cause = cause

    // Ensures the prototype chain is correct
    Object.setPrototypeOf(this, DataError.prototype)
  }

  toString = () => `
    Code: ${this.code}\n
    Message: ${this.message || '-'}\n
    Cause: ${this.cause ? ('toString' in this.cause ? this.cause.toString() : this.cause) : '-'}
  `
}

export default DataError
